import { Component, OnInit } from '@angular/core';
import {faFacebook,faTwitter,faPinterest,faLinkedin,faWordpress } from '@fortawesome/free-brands-svg-icons'
import { faNewspaper } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  faFacebook=faFacebook;
  faTwitter=faTwitter;
  faPinterest=faPinterest;
  faLinkedin=faLinkedin;
  faWordpress =faWordpress;
  faNewspaper=faNewspaper;
  constructor() { }

  ngOnInit() {
  }

}
